import script from "./turnstileVisible.vue?vue&type=script&setup=true&lang=js"
export * from "./turnstileVisible.vue?vue&type=script&setup=true&lang=js"

import "./turnstileVisible.vue?vue&type=style&index=0&id=25a55ef0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25a55ef0"]])

export default __exports__